<template>
	<v-container class="noMargin serviceFormHeader">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>DEPARTMENTAL SERVICE FORMS</h2>
          <v-flex lg12 style="padding: 12px;">
            <div class="screenTip">
            <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> This page is used to create additional service forms for departments.
              The service form link is created by Builders Warehouse - all you need to do is provide them with the Process ID.
                    </span>
            </div>
          </v-flex>
				</div>
				<v-btn @click.prevent="fncProcessAdd" v-if="fncCanDo()" class="elevation-5" color="info"><i class="material-icons">add</i>Create Departmental Service Form</v-btn>
				<v-btn @click.prevent="fncReloadDepartments" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
      <v-flex lg9>

      </v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
			}
		},
		methods: {
      fncCanDo() {
        if( this.objAuthorize.privileges.indexOf('AUDIT_SERVICE_FORMS') != -1 ) {
          return true;
        }
        return false;
      },
      fncProcessAdd() {
              this.$store.commit( 'setDepartmentLoader', true );
              this.$store.dispatch('fncPopulateUserRegions');
              this.$store.dispatch('fncBranchRanges', 'add');
              var modalDetails = { title: 'Add Departmental Service Forms', component: 'modal-process-add', mstate: true, params: {} };
              this.$store.commit({
                type: 'setModal',
                details: modalDetails
              });
          },
          fncReloadDepartments() {
            this.$store.commit('fncEmptyDepartments');
            this.$store.dispatch({
              type: 'fncPopulateDepartments',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
